module.exports = __webpack_public_path__ + "static/media/email-black.76069592.svg";